import { RuleValidation } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { ProductDiscountRuleState } from './types'

export function validateProductDiscountRule(rule: ProductDiscountRuleState): RuleValidation {
	if (rule.discount === null || rule.discount > 100 || rule.discount <= 0) {
		return { isValid: false, errors: { discount: 'invalid' } }
	}
	if (!rule.products || rule.products.length === 0) {
		return { isValid: false, errors: { products: 'empty' } }
	}
	return { isValid: true, errors: {} }
}
